<script setup lang="ts">
import { isEmpty } from 'lodash-es';
import { AppCellEllipsisProps } from './_types';

const props = withDefaults(defineProps<AppCellEllipsisProps>(), {
    maxVisibleChars: 40,
});

const textElement = useTemplateRef<HTMLDivElement>('text-element');

const showTooltip = computed<boolean>(() => {
    return !isEmpty(props.text) && !!textElement.value && textElement.value.offsetWidth < textElement.value.scrollWidth;
});
</script>
<template>
    <div ref="text-element" class="table-text-ellipsis" :style="{ 'max-width': `${maxVisibleChars}ch` }">
        {{ text }}
    </div>
    <q-tooltip v-if="showTooltip" square>{{ text }}</q-tooltip>
</template>
